import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Honeypot check
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      setFormMessage('提交成功！感谢您的留言，我们会尽快回复。');
      form.reset();
      setTimeout(() => { setFormStatus('idle'); setFormMessage(''); }, 5000);
      return;
    }

    setFormStatus('submitting');
    setFormMessage('');

    try {
      const submitData = new FormData(form);
      if (honeypot) submitData.delete('phone_alt');

      const response = await fetch('https://readdy.ai/api/form/d9oppj8senbniolesjhg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(submitData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse errors */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('提交成功！感谢您的留言，我们会尽快回复。');
        form.reset();
        setTimeout(() => { setFormStatus('idle'); setFormMessage(''); }, 5000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        setFormStatus('error');
        setFormMessage(serverMsg.includes('spam') || serverMsg.includes('form data is spam')
          ? '提交失败，请稍后重试。'
          : serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络连接后重试。');
    }
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于爆料网',
    description: '爆料网 - 网红爆料·娱乐爆料网·八卦爆料网，致力于为读者提供最新最全的网红八卦资讯',
    url: 'https://baoliaowang.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <Navbar />

      <main>
        {/* Header */}
        <section className="pt-20 pb-8 px-6 md:px-10 bg-background-100/60">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="mt-6">
              <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                关于爆料网
              </h1>
              <p className="text-sm text-foreground-600 mt-2 max-w-2xl">
                网红爆料·娱乐爆料·八卦爆料综合资讯平台
              </p>
            </div>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 px-6 md:px-10">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="md:w-2/3">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-foreground-700 leading-relaxed">
                  <p>
                    <strong>爆料网</strong>成立于2024年，是国内领先的网红娱乐八卦资讯平台。我们致力于为读者提供最新、最全、最真实的网红圈和娱乐圈爆料资讯，让每一位关注网红动态的用户都能在这里找到自己感兴趣的内容。
                  </p>
                  <p>
                    我们的编辑团队由资深娱乐记者和网红行业观察者组成，具备敏锐的新闻嗅觉和专业的采编能力。我们坚持"快速、全面、客观"的内容原则，每日更新海量爆料资讯，覆盖<strong>网红爆料、娱乐八卦、直播圈、短视频圈</strong>等多个垂直领域。
                  </p>
                  <p>
                    截至目前，爆料网已累计发布超过<strong>12,850篇</strong>爆料资讯，月度活跃读者超过<strong>35万人</strong>，月度阅读量突破<strong>860万次</strong>。我们已成为国内网红八卦领域最具影响力的资讯平台之一。
                  </p>
                  <p>
                    我们的使命是"让每一个瓜都被看见"，愿景是成为中文互联网上最值得信赖的网红娱乐资讯第一平台。我们相信，在信息爆炸的时代，真实、及时的资讯依然是稀缺品，而爆料网正是那个为读者筛选和呈现最优质内容的存在。
                  </p>
                </div>
              </div>
              <div className="md:w-1/3">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20office%20with%20multiple%20screens%20displaying%20news%20content%2C%20warm%20ambient%20lighting%2C%20professional%20newsroom%20atmosphere%2C%20creative%20workspace%2C%20clean%20minimalist%20design%2C%20crimson%20accent%20details%2C%20collaborative%20environment&width=500&height=500&seq=about-brand&orientation=squarish"
                  alt="爆料网编辑团队"
                  title="爆料网 - 专业编辑团队"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Stats */}
        <section className="py-12 md:py-16 px-6 md:px-10 bg-background-100/60">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
              平台口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { value: '12,850+', label: '累计爆料文章', icon: 'ri-article-line' },
                { value: '860万+', label: '月度阅读量', icon: 'ri-eye-line' },
                { value: '35万+', label: '忠实读者', icon: 'ri-user-heart-line' },
                { value: '98.5%', label: '读者好评率', icon: 'ri-thumb-up-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50">
                  <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${stat.icon} text-xl text-primary-600`}></i>
                  </div>
                  <div className="font-heading text-3xl font-bold text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Testimonials */}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                { quote: '"爆料网是我每天必刷的网站，更新速度真的快，很多瓜都是这里最先看到的！"', author: '资深吃瓜群众', role: '3年老读者' },
                { quote: '"作为自媒体人，爆料网是我获取选题灵感和行业动态的重要来源，内容质量和时效性都很棒。"', author: '娱乐自媒体人', role: '行业用户' },
                { quote: '"界面简洁干净，没有乱七八糟的广告弹窗，阅读体验很好。分类也很清晰，找想看的瓜很方便。"', author: '互联网从业者', role: '新用户' },
              ].map((item) => (
                <div key={item.author} className="p-5 rounded-lg bg-background-50">
                  <i className="ri-double-quotes-l text-2xl text-primary-300 mb-3 block"></i>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{item.quote}</p>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{item.author}</div>
                    <div className="text-xs text-foreground-500">{item.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-12 md:py-16 px-6 md:px-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              有任何问题、建议或爆料线索？欢迎随时联系我们！
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              {[
                { icon: 'ri-mail-line', title: '电子邮箱', content: 'contact@baoliaowang.com' },
                { icon: 'ri-wechat-line', title: '微信公众号', content: '爆料网' },
                { icon: 'ri-weibo-line', title: '官方微博', content: '@爆料网官方' },
              ].map((item) => (
                <div key={item.title} className="flex items-center gap-3 p-4 rounded-lg bg-background-100/70">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary-600`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">{item.title}</div>
                    <div className="text-sm font-medium text-foreground-950">{item.content}</div>
                  </div>
                </div>
              ))}
            </div>

            <form
              data-readdy-form="true"
              onSubmit={handleSubmit}
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  主题 <span className="text-primary-500">*</span>
                </label>
                <select
                  id="contact-subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                >
                  <option value="">请选择主题</option>
                  <option value="爆料投稿">爆料投稿</option>
                  <option value="商务合作">商务合作</option>
                  <option value="内容反馈">内容反馈</option>
                  <option value="侵权投诉">侵权投诉</option>
                  <option value="其他问题">其他问题</option>
                </select>
              </div>

              <div className="mb-4">
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors resize-none"
                  placeholder="请输入您的留言内容（最多500字）"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
              </div>

              {/* Anti-spam honeypot */}
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="spambot-trap"
              />

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {formStatus === 'submitting' ? '提交中...' : '提交留言'}
              </button>

              {formMessage && (
                <div
                  className={`mt-4 p-3 rounded-lg text-sm ${
                    formStatus === 'success'
                      ? 'bg-green-50 text-green-700 border border-green-200'
                      : 'bg-red-50 text-red-700 border border-red-200'
                  }`}
                >
                  {formMessage}
                </div>
              )}
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}